import React, {FC} from 'react';
import { useTranslation } from 'react-i18next';
import styles from './card-adjacent-plot.module.scss'
import {LandPlot} from "../../../../interfaces/card";
import positionIcon from '../../../../images/position.svg'
import {useAppDispatch} from "../../../../hooks/useAppDispatch";
import {deletePlotToMerge, setPlotToMerge} from "../../../../services/reducers/multiple-plot";
import {handleSelectCard} from "../../../../utils/cardNavigation";
import { focusOnFeature } from '../../../../services/actions/map';

interface AdjacentPlotCardProps {
    data: LandPlot
    type: 'addToMerge' | 'deleteToMerge'
}

const CardAdjacentPlot: FC<AdjacentPlotCardProps> = ({ data, type }) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const handleAddToMerge = () => {
        dispatch(setPlotToMerge(data))
    }

    const handleDeleteToMerge = () => {
        dispatch(deletePlotToMerge(data))
    }

    const handleShowDetails = () => {
        handleSelectCard(dispatch, 'Plots', data.fid.toString(), false);
    };

    const handleFocusOnObject = () => {
        dispatch(focusOnFeature({...data, label:""}))
    }

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <div className={styles.description}>
                    <span>{t('cardAdjacentPlot.plotNumber', {number: data.number})}</span>
                    <p>{t('cardAdjacentPlot.area', {area: data.area})}</p>
                </div>
                <button onClick={handleFocusOnObject}>
                    <img src={positionIcon} alt="position" />
                </button>
            </div>
            <div className={styles.buttons}>
                <button onClick={handleShowDetails} className={styles.detailsBtn}>{t('cardAdjacentPlot.showDetails')} <span className={styles.arrowMask} /></button>
                {type === 'addToMerge' ? (
                    <button onClick={handleAddToMerge} className={styles.multipleBtn}><span className={styles.iconPlus}/>{t('cardAdjacentPlot.addToList')}</button>
                ) : (
                    <button onClick={handleDeleteToMerge} className={styles.multipleBtn}><span className={styles.iconMinus}/>{t('cardAdjacentPlot.removeFromList')}</button>
                )}
            </div>
        </div>
    );
};

export default CardAdjacentPlot;
